import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { LoginWithGoogleResponseDTO } from "../models";

export type LoginWithGoogleCredsQueryParams = {
  googleResponse: TODO;
  referral?: string;
};

export abstract class GoogleApi {
  static async loginWithGoogleCreds({
    googleResponse,
    referral,
  }: LoginWithGoogleCredsQueryParams) {
    const response = GbApiRequestService.post(
      "registerGoogle",
      {
        requestType: "user",
        referralLink: referral,
        credential: googleResponse.credential,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    // return await response;
    return withSchemaValidation(response, LoginWithGoogleResponseDTO);
  }
}
